import { TransactionArgument, Transaction } from '@mysten/sui/transactions'
import { normalizeSuiObjectId } from '@mysten/sui/utils'
import {VAULTS_CONFIG} from "../../constant";

export class HaedalUtils {
  static requestStakeCoin(tx: Transaction, sui_coin: TransactionArgument) {
    const haedal = VAULTS_CONFIG.config.haedal
    const ha_sui_coin = tx.moveCall({
      target: `${haedal!.published_at}::staking::request_stake_coin`,
      typeArguments: [],
      arguments: [
        tx.object(normalizeSuiObjectId('0x5')),
        tx.object(haedal!.config!.staking_id),
        sui_coin,
        tx.pure.address(normalizeSuiObjectId('0x0')),
      ],
    })
    return ha_sui_coin
  }
}
